import * as s from './Panel/Panel.module.scss'

export const getFloatingPanelContainer = () => document.querySelectorAll(`.${s.wrapper}`)
